import React, { useState, useEffect } from "react";

// Constants
import Button from "react-bootstrap/Button";
import { ModalContext } from "./Modal/modalContext";

import { createCalendarEvent } from "../constants/api-methods";




const BookDatePopup = ({ date, start, end, eventInfo }) => {
  let { handleModal } = React.useContext(ModalContext);

  const { startDatetime, endDatetime, studioId, userId, contactId } = eventInfo;

  return (
    <div className="popup">
      <div className="book-date">
        <div className="title-ctn">
          <h3>{`Book ${date.toString().slice(0, 15)} from ${start} to ${end}`}</h3>
        </div>


        <div className="buttons-ctn">
          <Button
            disabled={false}
            className="cancel-btn"
            variant="outline-secondary"
            size="lg"
            onClick={() => {
              handleModal();
            }}
          >
            Cancel
          </Button>
          <Button
            className="add-btn"
            variant="outline-danger"
            size="lg"
            onClick={() => {
              createCalendarEvent(
                "TEST",
                startDatetime,
                endDatetime,
                studioId,
                userId,
                contactId
              );
              handleModal();
            }}
          >
            Book
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookDatePopup;
